import React from "react";
import { Box, Container, Typography, useTheme } from "@mui/material";
import Footer from "./Footer";
import Mission from "./Mission";

const AboutUs = () => {
    const theme = useTheme();

    return (
        <>
            <Box
                sx={{
                    pt: { xs: 10, md: 14 },
                    pb: { xs: 6, md: 2 },
                    px: 2,

                }}
            >


                <Container maxWidth="md">
                    <Typography
                        sx={{
                            fontSize: { xs: "20px", sm: "28px", md: "40px" },
                            fontWeight: 600,
                            textAlign: "center",
                            lineHeight: 1.1,
                            mb: 3,
                            animation: "fadeUp 0.9s ease-out both",
                            color: theme.palette.text.primary,
                            position: "relative",
                            display: "inline-block",
                            width: "100%",
                        }}
                    >
                        <Box
                            component="span"
                            sx={{
                                fontWeight: 900,
                                background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                position: "relative",
                                display: "inline-block",
                                "&::after": {
                                    content: '""',
                                    position: "absolute",
                                    bottom: "-4px",
                                    left: 0,
                                    width: "100%",
                                    height: "2px",
                                    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, transparent 100%)`,
                                }
                            }}
                        >
                            ArthGyan
                        </Box>{" "}
                        welcomes you
                    </Typography>




                    <Typography
                        variant="body1"

                        sx={{
                            textAlign: "center",
                            fontSize: { xs: "12px", sm: "14px", md: "16px" },
                            color: "#555",
                            maxWidth: 640,
                            mx: "auto",
                            // mb: 4,
                        }}

                    >
                        ArthGyan is designed to simplify your financial life — from managing
                        expenses across family members to exploring tailored options for
                        growing your wealth. Whether you're aiming for long-term goals or
                        exploring opportunities in mutual funds and equities, ArthGyan offers
                        a unified platform to support your every financial decision.
                    </Typography>
                </Container>

            </Box>

            <Mission />
            <Footer />
        </>
    );
};

export default AboutUs;
